.marginBottomFive {
	margin-bottom: 5px !important;
}

.marginVerticalTwenty {
	margin-top: 20px !important;
	margin-bottom: 20px !important;
}

.marginTopTwenty {
	margin-top: 20px !important;
}

.boldFont {
	font-weight: bold !important;
}
